

































































































import {Shard} from '@/store/modules/lib'
import {Component, Vue, Prop} from 'vue-property-decorator'
import Tooltip from '@/components/UI/Tooltip.vue';

const profile = namespace('profile')
const roistat = namespace('roistat')

import {namespace} from 'vuex-class';

@Component({
  name: 'c-shard-view',
  components: {
    Tooltip
  }
})
export default class ShardView extends Vue {
  @roistat.Action('sendEvent') protected sendEvent:any
  @profile.State("userCompany") protected userCompany: any
  @Prop(String) date!: string
  @Prop(Array) shards!: Shard[]
  @Prop({
    type: Object,
    default: () => {
      _id: 0
    }
  }) selectedShard!: { _id: number }
  @Prop(Boolean) hideDeferred!: boolean

  active: boolean = true
  @profile.State('profiles') protected badges: any

protected getFIO(shard:any){
    let fio = ''
  fio  =
  this.badges.filter((el:any) => el._id === shard._badge)[0].name.first + ' '+
  this.badges.filter((el:any) => el._id === shard._badge)[0].name.last
  return fio.length>20 ? fio.substring(0,20)+'...' : fio
}

  get filteredShards(): Shard[] {
    if (this.hideDeferred) {
      return this.shards.filter((shard: Shard) => !this.isDeferred(shard.target_type))
    }
    return this.shards
  }

  protected getTime(time: any) {
    return this.$moment(time, 'X')
      .locale('ru')
      .format('HH:mm')

  }

  protected selectShard(index: number): void {
    const shard = this.filteredShards[index]

    this.$emit('selectShard', shard)
    let params = [
      {
        "name": "“Собранные данные”: Действие “Показать информацию”",
        "data": {
          "company": this.userCompany.title
        }
      }
    ]
    this.sendEvent(params)
  }

  protected isDeferred(type: string): boolean {
    return type === 'pending_badge' || type === 'pending_stand' || type === 'pending_product'
  }

  protected pendingType(targetType: string): string {
    const regexp = /pending_/

    if (regexp.test(targetType)) {
      return targetType.substring(8, targetType.length)
    }

    return ''
  }

  protected pendingTitle(targetType: string): string {
    switch (this.pendingType(targetType)) {
      case 'badge':
        return 'Бейдж'

      case 'stand':
        return 'Стенд'

      case 'product':
        return 'Продукт'

      default:
        return ''
    }
  }

  protected isCustom(type: string): boolean {
    return type === 'custom_contact'
  }
}
